import React from "react";
import { Layout, Menu } from "antd";
import {
    DashboardOutlined,
    ShoppingCartOutlined,
    DollarOutlined,
    BarChartOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Sider } = Layout;

const Sidebar = () => {
    const navigate = useNavigate();

    return (
        <Sider breakpoint="lg" collapsedWidth="0">
            <div style={{ color: "#fff", padding: 16, fontWeight: "bold" }}>
                ASSIGANTO
            </div>

            <Menu
                theme="dark"
                mode="inline"
                onClick={({ key }) => navigate(key)}
                items={[
                    {
                        key: "/account/dashboard",
                        icon: <DashboardOutlined />,
                        label: "Tableau de bord",
                    },
                    {
                        key: "/account/orders",
                        icon: <ShoppingCartOutlined />,
                        label: "Mes commandes",
                    },
                    {
                        key: "/account/sales",
                        icon: <DollarOutlined />,
                        label: "Mes ventes",
                    },
                    {
                        key: "/account/earnings",
                        icon: <BarChartOutlined />,
                        label: "Mes gains",
                    },
                ]}
            />
        </Sider>
    );
};

export default Sidebar;